module.exports = __webpack_public_path__ + "static/media/Hbook-09.4314745b.jpg";